import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { InRoomCredentialsEffects } from './in-room-credentials.effects';
import { inRoomCredentialsReducer } from './in-room-credentials.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('inRoomCredentials', inRoomCredentialsReducer),
    EffectsModule.forFeature([InRoomCredentialsEffects]),
  ],
  providers: [],
})
export class InRoomCredentialsStoreModule {}
